import React from 'react'
import {
  FormControl,
  TextField,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Box,
  type TextFieldProps,
  type SxProps,
  type Theme,
} from '@mui/material'
import { styled } from '@mui/material/styles'

import { ChevronDownIcon } from '@/assets/icons/chevron-icons'
const CustomizedChevronDownIcon = styled(ChevronDownIcon)`
  width: 20px;
  height: 20px;
  color: #667085;
`
const iconContainerStyles = {
  '& .MuiSelect-icon': {
    top: '50%',
    transform: 'translateY(-50%)',
    color: '#667085',
  },
  '& .MuiSelect-iconOpen': {
    transform: 'translateY(-50%) rotate(180deg)',
  },
}

interface Option {
  value: string
  label: string
  icon?: React.ReactNode
}
interface OptionSelectInputProps extends Omit<TextFieldProps, 'value' | 'onChange'> {
  value: string
  setValue: (value: string) => void
  options?: Option[]
  inputStyles?: SxProps<Theme>
  customStyles?: SxProps<Theme>
  menuStyles?: SxProps<Theme>
  placeholder?: string
  noOptionsMessage?: string
}

export function OptionSelectInput({
  value,
  setValue,
  options = [],
  inputStyles = {},
  customStyles = {},
  menuStyles = {},
  placeholder = 'Please Select',
  noOptionsMessage = 'No options available',
  ...rest
}: OptionSelectInputProps) {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    event.preventDefault()
    event.stopPropagation()
    setValue(event.target.value)
  }

  return (
    <FormControl
      fullWidth
      size="small"
      sx={{
        ...iconContainerStyles,
        '& .MuiOutlinedInput-notchedOutline': { borderRadius: '16px !important' },
        '& .MuiFormControl-root': { mr: '0px !important' },
        ...customStyles,
      }}
    >
      <TextField
        select
        SelectProps={{
          IconComponent: CustomizedChevronDownIcon,
          displayEmpty: true,
          renderValue: selected => {
            const selectedOption = options.find(option => option.value === selected)

            return selectedOption ? (
              <Box alignItems="center" display="flex" gap="8px">
                {selectedOption.icon ? (
                  <ListItemIcon style={{ minWidth: 'auto', marginRight: 0 }}>{selectedOption.icon}</ListItemIcon>
                ) : null}
                <ListItemText
                  primary={selectedOption.label}
                  sx={{ '& .MuiListItemText-primary': { fontWeight: 500 } }}
                />
              </Box>
            ) : (
              placeholder
            )
          },
          MenuProps: {
            PaperProps: {
              sx: {
                borderRadius: '16px',
                border: '1px solid #E9EAEB',
                background: '#FFF',
                boxShadow:
                  '0px 12px 16px -4px rgba(10, 13, 18, 0.08), 0px 4px 6px -2px rgba(10, 13, 18, 0.03), 0px 2px 2px -1px rgba(10, 13, 18, 0.04)',
                ...menuStyles,
              },
            },
          },
        }}
        inputProps={{
          'aria-label': placeholder || 'Select option',
        }}
        sx={{
          ...inputStyles,
        }}
        value={value}
        onChange={handleChange}
        {...rest}
      >
        <MenuItem disabled sx={{ display: 'none' }} value="">
          {placeholder}
        </MenuItem>
        {options.length > 0 ? (
          options.map(option => (
            <MenuItem key={option.value} value={option.value}>
              {/* {option.icon ? (
                <ListItemIcon style={{ minWidth: 'auto', marginRight: 8 }}>{option.icon}</ListItemIcon>
              ) : null} */}
              <ListItemText primary={option.label} />
            </MenuItem>
          ))
        ) : (
          <MenuItem disabled value="">
            {noOptionsMessage}
          </MenuItem>
        )}
      </TextField>
    </FormControl>
  )
}
